import { useQuery } from "@tanstack/react-query";
import { settingsMapOptions } from "../api/queries";
import { getSetting } from "./get-setting";
import type { AppSettings, KnownSettingKey } from "@/shared/lib/db-schema";

export function useSettings(): {
  settings: Partial<AppSettings>;
  get: <K extends KnownSettingKey>(key: K) => AppSettings[K];
  isLoading: boolean;
} {
  const query = useQuery(settingsMapOptions());
  const map = query.data ?? {};
  return {
    settings: map,
    get: <K extends KnownSettingKey>(key: K) => getSetting(map, key),
    isLoading: query.isLoading,
  };
}
